import type { CreditBureauConfig } from "@/lib/api/applicationService";
import type { CreditBureauDisplay } from '../types/utils'



/** Bureau contact block for acknowledgment copy (Angular `summary-info` / Signature tab). */
export function getCreditBureauDisplay(
  config: CreditBureauConfig | null | undefined,
): CreditBureauDisplay {
  const isEquifax = config?.active === "Equifax" || !config;
  const details = config?.details;
  return {
    name: details?.config_value || "Equifax Information Services, LLC",
    address: details
      ? `${details.cb_addressline1 || ""}, ${details.cb_city || ""}, ${details.cb_state || ""} ${details.cb_zipcode || ""}`.trim()
      : "P.O. Box 740256, Atlanta, GA 30374",
    phone: details?.cb_telephone || "(866) 349-5191",
    fax: details?.cb_fax || "",
    web: isEquifax ? "https://www.equifax.com/personal/" : "",
    isEquifax,
    equifaxHint: isEquifax
      ? "(Look for the Free Credit Report, Lifting Freezes, Correcting or Disputing your credit information)"
      : "",
  };
}
